<template>
	<div class="common-box">
		<el-form inline ref="form" class="search-form common-box-search-form" label-position="right" :model="form"
			label-width="70px">
			<search-form @search="handleSearch" @refresh="handleRefresh">
				<div slot="content">
					<el-form-item label="客户名称：">
						<el-input @change="handleSearchListData" size="mini" v-model.trim="form.operatorName" placeholder="请输入客户名称"
							clearable></el-input>
					</el-form-item>
					<el-form-item label="项目名称：">
						<el-input @change="handleSearchListData" size="mini" v-model.trim="form.projectName" placeholder="请输入项目名称"
							clearable></el-input>
					</el-form-item>
					<el-form-item label="记录时间：">
              <el-date-picker
                v-model="createTime"
                size="mini"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                unlink-panels
                clearable
                @change="handleSearchListData"
              ></el-date-picker>
            </el-form-item>
				</div>
			</search-form>
		</el-form>
		<div class="common-cover-div"></div>
		<div class="operation-and-table__container">
			<div class="btns__container">
				<el-button v-if="hasRole['BFJLTJ']" size="mini" type="primary" class="plr28" @click="handleAdd">添加</el-button>
				<el-button size="mini" type="primary" class="plr28" @click="handleDelete" v-if="hasRole['BFJLSC']" plain>删除
				</el-button>
			</div>
			<div class="table__container">
				<el-table v-loading="tableLoading" :data="list" height="100%" border style="width: 100%"
					@selection-change="handleSelectionChange">
					<el-table-column type="selection" width="40"></el-table-column>
					<el-table-column type="index" label="序号" width="100"></el-table-column>
					<el-table-column show-overflow-tooltip prop="nextVisitTime" label="拜访日期"></el-table-column>
					<el-table-column show-overflow-tooltip prop="projectName" label="项目名称"></el-table-column>
					<el-table-column show-overflow-tooltip prop="operatorName" label="联系人员"></el-table-column>
					<el-table-column show-overflow-tooltip prop="content" label="沟通内容"></el-table-column>
					<el-table-column show-overflow-tooltip prop="content" label="图片">
						<template slot-scope="scope">
							<el-image v-if="scope.row.imageUrlList" style=" height: 28px" :src="scope.row.imageUrlList.split(',')[0]" :preview-src-list="scope.row.imageUrlList.split(',')">
							</el-image>
						</template>
					</el-table-column>

					<el-table-column label="操作" width="98px" fixed="right">
						<template slot-scope="scope">
							<el-button size="mini" v-if="hasRole['BFJLBJ']" type="text" @click="handleEdit(scope.row)">编辑</el-button>
							<div class="btn-divide" v-if="hasRole['BFJLSC']"></div>
							<el-button size="mini" type="text" v-if="hasRole['BFJLSC']" @click="handleDeleteCause(scope.row)">删除
							</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="pagenation__container">
				<div class="for-fff-bg">
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex"
						:page-sizes="[25, 50, 100, 150, 200]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
						:total="total"></el-pagination>
				</div>
			</div>
		</div>
		<add-cause v-if="addCauseVisible" @cancel="addCauseVisible = false" @confirm="handleAddCauseConfirm"></add-cause>
		<edit-cause v-if="editCauseVisible" :detail="causeDetail" @cancel="editCauseVisible = false"
			@confirm="handleEditCauseConfirm"></edit-cause>
	</div>
</template>

<script>
import {
	getPageList,
	deleteData,
} from "@/api/salesManagement/bfjl";

import AddCause from "./components/AddCause";
import EditCause from "./components/EditCause";
export default {
	name: "SalesManagementBFJL",
	components: {
		AddCause,
		EditCause,
	},
	data() {
		return {
			form: {
				projectName:"",
				operatorName: ""
			},
			tableLoading: false,
			list: [],
			multipleSelection: [],
			pageIndex: 1,
			pageSize: 50,
			total: 0,
			addCauseVisible: false,
			editCauseVisible: false,
			checkDepartment: false,
			causeDetail: {},
			createTime: null
		};
	},
	computed: {
		hasRole: function () {
			return this.$store.getters["common/promise/getRole"](this.$route.path);
		},
	},
	created() {
		this.getListData();
	},
	methods: {
		async getListData() {
			this.tableLoading = true;
			const params = {
				pageIndex: this.pageIndex,
				pageSize: this.pageSize,
			};
			for (let key in this.form) {
				if (this.form[key]) params[key] = this.form[key];
			}
			if (this.createTime && this.createTime.length) {
        this.form.operatorTimeStart = this.createTime[0];
        this.form.operatorTimeEnd = this.createTime[1];
      } else {
        this.form.operatorTimeStart = ""
        this.form.operatorTimeEnd = ""
      }
			const res = await getPageList(params);
			if (res.code === 200) {
				this.total = res.data.total;
				this.list = res.data.list;
			}
			this.tableLoading = false;
		},
		handleSearch() {
			this.pageIndex = 1;
			this.getListData();
		},
		handleRefresh() {
			for (let key in this.form) {
				if (Array.isArray(this.form[key])) {
					this.form[key] = [];
				} else {
					this.form[key] = "";
				}
				this.createTime = null
			}
			this.pageIndex = 1;
			this.getListData();
		},
		handleSearchListData() {
			this.pageIndex = 1;
			this.getListData();
		},
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},
		handleDeleteCause(row) {
			const idList = [row.id];
			this.deleteCause(idList);
		},
		handleCheck(row) {
			this.causeDetail = row;
			this.checkDepartment = true;
		},
		handleEdit(row) {
			this.causeDetail = row;
			this.editCauseVisible = true;
		},
		handleDelete() {
			if (!this.multipleSelection.length) {
				this.$message.warning("请选择要删除的行");
				return;
			}
			const idList = this.multipleSelection.map((item) => item.id);
			this.deleteData(idList);
		},
		deleteCause(idList) {
			this.$confirm("确定删除?", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			})
				.then(async () => {
					const res = await deleteData({
						idList,
					});
					if (res.code === 200) {
						this.$message.success("删除成功");
						this.getListData();
					}
				})
				.catch((err) => {
					console.log(err);
				});
		},
		handleAdd() {
			this.addCauseVisible = true;
		},
		exportCause() {
			const params = {
				pageIndex: this.pageIndex,
				pageSize: this.pageSize,
			};
			for (let key in this.form) {
				if (this.form[key]) params[key] = this.form[key];
			}
			exportCause(params);
		},
		handleSizeChange(val) {
			this.pageSize = val;
			this.getListData();
		},
		handleCurrentChange(val) {
			this.pageIndex = val;
			this.getListData();
		},
		handleAddCauseConfirm() {
			this.addCauseVisible = false;
			this.pageIndex = 1;
			this.getListData();
		},
		handleEditCauseConfirm() {
			this.editCauseVisible = false;
			this.getListData();
		},
	},
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/pages/salesManagement/bfjl/SalesManagementBFJL.vue